export default __webpack_public_path__ + "static/media/sticky.1d37a7f8.svg";